import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: '⬇️ Download Istantaneo',
  desc: "Acquista e ottieni accesso immediato all'ebook completo e a tutti i 5 bonus. Inizia quando vuoi, senza attese."
}, {
  n: '2',
  title: '👁️ Segui il Metodo Visivo',
  desc: "Impara Hangeul, pronuncia, vocabolario e frasi in un ordine pensato perché non ti perda mai. Il sistema è la tua mappa."
}, {
  n: '3',
  title: '🎯 Completa la Routine di 60 Minuti',
  desc: 'Studia passo a passo, pratica ciò che hai imparato e consolida la memoria per parlare con vera sicurezza in 60 minuti.'
}];
export function Steps() {
  return <section aria-label="Come funziona" className="bg-transparent" data-id="element-182" data-mp="fpfkz7wy6zhc">
      <div className="mx-auto max-w-4xl px-5 py-12" data-id="element-183" data-mp="fppdb25gtiq7">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-184" data-mp="261lnz3tc61b1">
          Come Avanzerai da Oggi
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-185" data-mp="2a2nnllr60fdj">In 3 semplici passi</p>

        <ol className="mt-10 space-y-4" data-id="element-186" data-mp="1qa11zqrt7ded">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-187" data-mp="1ld0x3j6p4gou" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-188" data-mp="12e6kogupfsbu">
                {s.n}
              </span>
              <div data-id="element-189" data-mp="1cbb78hsgppt6">
                <h3 className="text-base font-bold text-plum" data-id="element-190" data-mp="1carowzywgzem">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-191" data-mp="2sp1d9u356o5g">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}